<template>
  <div class="gfr-slide-menu-content">
    <slot />
  </div>
</template>
<script lang="ts" setup></script>
